(() => {
  function initialiseMenaboSelector(selector) {
    if (selector.dataset.menaboReady === 'true') return;

    const picker = selector.closest('variant-picker');
    const form = selector.closest('.variant-picker__form');

    if (!picker || !form) return;

    const radioName = selector.dataset.radioName;

    const radios = Array.from(
      form.querySelectorAll('input[type="radio"]')
    ).filter((radio) => radio.name === radioName);

    if (!radios.length) return;

    selector.dataset.menaboReady = 'true';

    const minus = selector.querySelector('[data-menabo-minus]');
    const plus = selector.querySelector('[data-menabo-plus]');
    const value = selector.querySelector('[data-menabo-value]');

    if (!minus || !plus || !value) return;

    const getIndex = () => {
      const index = radios.findIndex((radio) => radio.checked);
      return index >= 0 ? index : 0;
    };

    const refresh = () => {
      const index = getIndex();

      value.textContent = radios[index].value;
      minus.disabled = index === 0;
      plus.disabled = index === radios.length - 1;
    };

    const selectVariant = (index) => {
      if (index < 0 || index >= radios.length) return;

      radios[index].click();
      refresh();
    };

    minus.addEventListener('click', () => {
      selectVariant(getIndex() - 1);
    });

    plus.addEventListener('click', () => {
      selectVariant(getIndex() + 1);
    });

    radios.forEach((radio) => {
      radio.addEventListener('change', refresh);
    });

    refresh();
  }

  function initialiseAllMenaboSelectors(root = document) {
    root
      .querySelectorAll('[data-menabo-room-selector]')
      .forEach(initialiseMenaboSelector);
  }

  document.addEventListener('DOMContentLoaded', () => {
    initialiseAllMenaboSelectors();
  });

  document.addEventListener('shopify:section:load', (event) => {
    initialiseAllMenaboSelectors(event.target);
  });

  document.addEventListener('shopify:block:select', (event) => {
    initialiseAllMenaboSelectors(event.target);
  });

  initialiseAllMenaboSelectors();document.addEventListener('change', (event) => {
  const variantControl = event.target.closest(
    'variant-picker, .variant-picker__form, [data-product-form]'
  );

  const pricePrefix = document.querySelector(
    '[data-menabo-price-prefix]'
  );

  if (!variantControl || !pricePrefix) return;

  document.documentElement.classList.add('menabo-price-selected');
});
})();